var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label label-default",class:{
        'implanted': _vm.status.id == 'IMPLANTED',
        'started': _vm.status.id == 'STARTED',
        'waiting-first-request': _vm.status.id == 'WAITING_REQUEST',
        'suspended': _vm.status.id == 'SUSPENDED',
        'on-alert': _vm.status.id == 'ON_ALERT',
        'on-watch':  _vm.status.id == 'ON_WATCH' }},[_vm._v(" "+_vm._s(_vm.status.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }